module.exports = __webpack_public_path__ + "static/mathewbourn-7c10484c57fd96b6d62f68315b4dbbbb.jpg";